import * as React from "react";
import QueryString from "query-string";
// url
import { VingleURL } from "@vingle/wtf-sdk/url";
// components
import SignInForm from "./components/signInForm";
import AuthRedirect, {
  ACCESS_PERMISSION_OPTIONS,
} from "@vingle/wtf-sdk/components/authRedirect";
import SignUpNavbar from "common/components/signupNavbar";
import PageUpdater from "@vingle/wtf-sdk/components/pageUpdater";

import { useProps } from "./hooks";

export default React.memo(() => {
  const { location } = useProps();
  const [redirectTo, setRedirectTo] = React.useState(
    new VingleURL.Home().toString(),
  );

  React.useEffect(() => {
    setRedirectTo(QueryString.parse(location.search).redirect_url as string);
  }, [location.search]);

  return (
    <div>
      <PageUpdater title="Sign In" />
      <AuthRedirect
        targetPath={redirectTo}
        permission={ACCESS_PERMISSION_OPTIONS.UNSIGNED_USER_ONLY}
      />
      <SignUpNavbar />
      <SignInForm redirectTo={redirectTo} />
    </div>
  );
});
